import { formatDate } from '@angular/common';

export function dateFormatter(dataItemValue: string | number | Date, locale: string = 'en-NZ') {
  return formatDate(dataItemValue, 'd MMM y', locale);
}
